<div
  class="bid-summary-report regular-font-size"
  [class.hide-bid-summary-page]="showMenu"
>
  <!--  Toolbar-->
  <div class="toolbar row justify-content-center m-0">
    <div class="toolbar-content col-xl-10 col-12">
      <a class="k2-logo me-3" href="https://k2corporatemobility.com">
        <img
          class="k2-logo-img"
          src="{{
            data?.k2_logo
              ? 'data:image/png;base64,' + data.k2_logo
              : 'bid-summary/k2_blue_logo.png'
          }}"
          alt="K2 Logo"
        />
      </a>
      <div class="bid-summary-navigation">
        @for (item of navigations; track item) {
        <div
          class="navigation-item small-font-size font-weight-400"
          [class.selected]="selectedNavigationItem === item.link"
          (click)="scrollTo(item.link)"
        >
          {{ item.title }}
        </div>
        }
      </div>

      <div class="navigation-btn" (click)="onMenuClick()">
        <i class="fa fa-bars"></i>
      </div>
    </div>
  </div>

  @if (!!data) {
  <div class="content" (scroll)="onScroll($event)">
    <!--    Button 'go to top'-->
    <div
      [@fromBottom]="showGoToTopBtn"
      class="go-to-top-btn"
      (click)="scrollTo('')"
    >
      <div class="before"><i class="fa fa-angle-up"></i></div>
      <div class="after"><i class="fa fa-angle-up"></i></div>
    </div>
    <div id="first-item" class="small-divider"></div>
    <!--    Moving Cost Estimate-->
    <div class="row overflow-hidden item">
      <div class="col-10">
        <div class="row">
          <div
            class="client-logo col-10 col-md-3 col-lg-2"
            [class.client-name]="!data.client_logo_image"
          >
            @if (data?.client_logo_image) {
            <img
              [src]="'data:image/png;base64,' + data.client_logo_image"
              alt="Client Logo"
              width="100%"
            />
            } @else {
            {{ data.client_name }}
            }
          </div>
          <div class="col-10 col-md-9 col-lg-10">
            <div class="mce-title large-font-size font-weight-100">
              Moving Cost Estimate (MCE)
            </div>
            <div class="k2-ref font-weight-500 pb-20">
              K2 Assignee Reference: {{ data.k2_id }}
            </div>
            @if (data.policy_data?.policy) {
            <div
              class="d-flex align-items-center flex-wrap small-font-size pb-20"
            >
              <div class="info-badge blue-background mt-20 me-3">
                This assignment is within policy
              </div>
              @if (data.policy_data.policy_text) {
              <div class="blue-color font-weight-300 pt-20">
                <strong>Your Policy:</strong> {{ data.policy_data.policy_text }}
              </div>
              }
            </div>
            }
            <div class="d-flex">
              <div
                class="navigation-btn small-font-size d-flex align-items-center"
                (click)="scrollTo('trusted-partner')"
              >
                View your costs
                <div class="btn-icon"><i class="fa fa-arrow-down"></i></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="small-divider"></div>
      <div class="animate-up col-10 pt-20 border-bottom"></div>
    </div>
    <div class="small-divider"></div>
    <div id="info-icons" class="row item overflow-hidden">
      <div class="row col-10 px-0 mx-0 justify-content-between">
        <div class="status-card col-lg-2 col-sm-6 col-12 pt-20">
          <span class="info-icon green-info-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="36"
              height="36"
              viewBox="0 0 32 32"
            >
              <path
                d="M6.667 20h4v1.333h-4v-1.333zM9.333 16h1.333v4h-1.333v-4zM6.667 16h1.333v4h-1.333v-4zM6.667 14.667h4v1.333h-4v-1.333zM12 16h1.333v1.333h-1.333v-1.333zM12 18.667h1.333v1.333h-1.333v-1.333zM14.667 14.667h4v1.333h-4v-1.333zM14.667 16h1.333v4h-1.333v-4zM14.667 20h4v1.333h-4v-1.333zM17.333 16h1.333v4h-1.333v-4zM20 14.667h4v1.333h-4v-1.333zM20 16h1.333v4h-1.333v-4zM20 20h4v1.333h-4v-1.333zM22.667 16h1.333v4h-1.333v-4zM26.667 25.333h-22.667v-14.667h22.667v14.667zM5.333 24h20v-12h-20v12zM24.667 32h-17.333c-4.044 0-7.333-3.291-7.333-7.333v-13.333c0-0.309 0.041-0.609 0.084-0.912l0.045-0.307 0.281-0.279 9.483-5.836h12.211l9.751 6 0.043 0.309c0.060 0.415 0.101 0.713 0.101 1.024v13.333c0.001 4.043-3.288 7.333-7.332 7.333zM1.377 10.807c-0.027 0.196-0.044 0.36-0.044 0.527v13.333c0 3.307 2.692 6 6 6h17.333c3.307 0 6-2.693 6-6v-13.333c0-0.179-0.021-0.355-0.043-0.527l-8.896-5.473h-11.456l-8.895 5.473zM20 5.333h-8v-5.333h8v5.333zM13.333 4h5.333v-2.667h-5.333v2.667zM2.432 9.887l-2.445-3.972 6.813-4.193 2.447 3.973-1.136 0.699-1.747-2.839-4.543 2.797 1.747 2.839zM29.568 9.887l-1.136-0.696 1.747-2.839-4.543-2.797-1.747 2.839-1.137-0.699 2.448-3.973 6.813 4.193z"
              ></path>
            </svg>
          </span>
          <div
            class="status-card-title slightly-bigger-font-size font-weight-500 solid-green-color"
          >
            Your assignment has been initiated
          </div>
          <div class="small-font-size pt-20">
            We have been in touch with the assignee and initiated the assignment
            process with them
          </div>
        </div>
        <div class="status-card col-lg-2 col-sm-6 col-12 pt-20">
          <span class="info-icon green-info-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="36"
              height="36"
              viewBox="0 0 32 32"
            >
              <path
                d="M28.667 32h-25.333c-0.368 0-0.667-0.3-0.667-0.667v-30.667c0-0.367 0.299-0.667 0.667-0.667h25.333c0.367 0 0.667 0.3 0.667 0.667v30.667c0 0.367-0.3 0.667-0.667 0.667zM4 30.667h24v-29.333h-24v29.333zM16.273 13.057c-2.396 0-4.2-3.536-4.2-5.829 0-2.316 1.884-4.199 4.2-4.199 2.315 0 4.2 1.883 4.2 4.199 0 2.293-1.804 5.829-4.2 5.829zM16.273 4.361c-1.581 0-2.867 1.287-2.867 2.864 0 1.693 1.389 4.496 2.867 4.496 1.451 0 2.867-2.845 2.867-4.496 0-1.58-1.285-2.864-2.867-2.864zM16.273 20.361c-3.875 0-7.028-2.235-7.028-4.98 0-1.789 1.379-4.623 3.685-6.265l0.773 1.084c-1.869 1.333-3.125 3.752-3.125 5.18 0 1.975 2.608 3.645 5.695 3.645 3.085 0 5.695-1.671 5.695-3.645 0-1.425-1.256-3.849-3.128-5.18l0.773-1.084c2.307 1.641 3.688 4.475 3.688 6.265 0.001 2.747-3.153 4.98-7.028 4.98zM24 24h-14.667c-0.368 0-0.667-0.3-0.667-0.667s0.299-0.667 0.667-0.667h14.667c0.367 0 0.667 0.3 0.667 0.667s-0.3 0.667-0.667 0.667zM24 28h-14.667c-0.368 0-0.667-0.3-0.667-0.667s0.299-0.667 0.667-0.667h14.667c0.367 0 0.667 0.3 0.667 0.667s-0.3 0.667-0.667 0.667z"
              ></path>
            </svg>
          </span>
          <div
            class="status-card-title slightly-bigger-font-size font-weight-500 solid-green-color"
          >
            Property, technical household goods survey
          </div>
          <div class="small-font-size pt-20">
            We have surveyed the assignees property & belongings to create our
            facts & figures
          </div>
        </div>
        <div class="status-card col-lg-2 col-sm-6 col-12 pt-20">
          <span class="info-icon green-info-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="36"
              height="36"
              viewBox="0 0 32 32"
            >
              <path
                d="M30.72 32h-29.44c-0.353 0-0.64-0.288-0.64-0.64v-30.72c0-0.352 0.287-0.64 0.64-0.64h29.44c0.353 0 0.639 0.288 0.639 0.64v30.72c0.001 0.352-0.285 0.64-0.639 0.64zM1.92 30.72h28.16v-29.44h-28.16v29.44zM30.080 7.68h-28.16c-0.353 0-0.64-0.288-0.64-0.64s0.287-0.64 0.64-0.64h28.16c0.353 0 0.64 0.288 0.64 0.64s-0.288 0.64-0.64 0.64zM30.080 17.92h-28.16c-0.353 0-0.64-0.288-0.64-0.64s0.287-0.64 0.64-0.64h28.16c0.353 0 0.64 0.287 0.64 0.64s-0.288 0.64-0.64 0.64zM30.080 11.52h-28.16c-0.353 0-0.64-0.288-0.64-0.64s0.287-0.64 0.64-0.64h28.16c0.353 0 0.64 0.288 0.64 0.64s-0.288 0.64-0.64 0.64zM27.52 5.12h-2.56c-0.352 0-0.639-0.288-0.639-0.64s0.288-0.64 0.639-0.64h2.56c0.353 0 0.64 0.288 0.64 0.64s-0.288 0.64-0.64 0.64zM27.52 15.36h-2.56c-0.352 0-0.639-0.288-0.639-0.64s0.288-0.64 0.639-0.64h2.56c0.353 0 0.64 0.288 0.64 0.64s-0.288 0.64-0.64 0.64zM26.24 21.76h-20.48c-0.353 0-0.64-0.288-0.64-0.64s0.287-0.639 0.64-0.639h20.48c0.353 0 0.64 0.287 0.64 0.639s-0.288 0.64-0.64 0.64zM19.84 28.16h-14.080c-0.353 0-0.64-0.288-0.64-0.64s0.287-0.639 0.64-0.639h14.080c0.353 0 0.64 0.288 0.64 0.639 0 0.352-0.287 0.64-0.64 0.64zM19.84 24.32h-14.080c-0.353 0-0.64-0.288-0.64-0.64s0.287-0.639 0.64-0.639h14.080c0.353 0 0.64 0.288 0.64 0.639 0 0.352-0.287 0.64-0.64 0.64z"
              ></path>
            </svg>
          </span>
          <div
            class="status-card-title slightly-bigger-font-size font-weight-500 solid-green-color"
          >
            Technical facts, costs & service summary received
          </div>
          <div class="small-font-size pt-20">
            We’ve shared our recommended assignment facts, costs & service
            summary figures with you
          </div>
        </div>
        <div class="status-card col-lg-2 col-sm-6 col-12 pt-20">
          <span
            class="info-icon"
            [ngClass]="
              data.client_approved ? 'green-info-icon' : 'red-info-icon'
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="36"
              height="36"
              viewBox="0 0 32 32"
            >
              <path
                d="M15.796 25.284c-0.756 0-1.476-0.289-1.899-0.568-0.719-0.472-5.948-4.844-6.543-5.341l-1.813-1.527c-0.281-0.237-0.316-0.659-0.079-0.94 0.235-0.28 0.656-0.317 0.94-0.081l1.809 1.524c2.855 2.389 5.976 4.959 6.419 5.251 0.32 0.211 0.889 0.393 1.34 0.341 0.383-0.047 0.5-0.239 0.559-0.401 0.076-0.208 0.251-0.365 0.469-0.417 0.219-0.055 0.443 0.005 0.609 0.155 0.393 0.36 1.008 0.392 1.415 0.233 0.203-0.080 0.455-0.241 0.481-0.552 0.025-0.253 0.191-0.472 0.427-0.563s0.505-0.037 0.693 0.137c0.191 0.175 0.641 0.169 1.009-0.013 0.204-0.101 0.54-0.336 0.497-0.749-0.028-0.259 0.097-0.511 0.321-0.644 0.221-0.133 0.503-0.123 0.719 0.025 0.196 0.137 0.448 0.029 0.601-0.103 0.249-0.212 0.425-0.62 0.18-1.133-0.759-1.579-4.811-5.424-7.305-7.168l-0.021 0.007c-0.708 0.257-0.785 0.28-1.311 0.332-0.661 0.96-1.977 2.6-3.943 1.951-0.623-0.205-1.048-0.673-1.199-1.32-0.337-1.448 0.744-3.459 1.656-4.355 1.5-1.471 4.249-2.743 7.059-1.483 2.601 1.164 4.221 1.644 4.237 1.649 0.355 0.104 0.557 0.473 0.453 0.827s-0.472 0.557-0.827 0.452c-0.069-0.020-1.713-0.507-4.408-1.712-2.199-0.983-4.381 0.041-5.583 1.219-0.736 0.724-1.477 2.297-1.289 3.099 0.045 0.196 0.135 0.297 0.317 0.357 0.996 0.329 1.732-0.403 2.595-1.691 0.111-0.165 0.289-0.272 0.487-0.292l0.245-0.024c0.444-0.043 0.444-0.043 1.053-0.264l0.344-0.125c0.197-0.071 0.421-0.044 0.597 0.073 2.412 1.608 7.071 5.869 8.040 7.889 0.472 0.983 0.271 2.052-0.515 2.723-0.388 0.332-0.847 0.503-1.305 0.484-0.188 0.484-0.572 0.901-1.104 1.167-0.552 0.273-1.161 0.344-1.692 0.221-0.232 0.361-0.587 0.648-1.037 0.823-0.695 0.268-1.484 0.232-2.141-0.068-0.305 0.319-0.725 0.52-1.229 0.579-0.109 0.012-0.22 0.017-0.331 0.017zM13.651 9.495c-0.024 0-0.048-0.001-0.073-0.004-1.367-0.148-4.629-0.245-5.676-0.213-0.311 0.023-0.675-0.279-0.685-0.647-0.012-0.368 0.279-0.675 0.645-0.687 1.103-0.032 4.417 0.065 5.86 0.223 0.365 0.039 0.631 0.368 0.591 0.733-0.035 0.343-0.325 0.595-0.661 0.595zM24.735 20.024c-0.201 0-0.401-0.091-0.531-0.263-0.223-0.293-0.167-0.711 0.128-0.935l1.305-0.989c0.293-0.221 0.712-0.167 0.933 0.128s0.167 0.713-0.128 0.935l-1.305 0.991c-0.12 0.088-0.263 0.133-0.403 0.133zM22.789 22.364c-0.144 0-0.289-0.047-0.413-0.143-0.699-0.552-4.36-3.972-4.515-4.117-0.269-0.251-0.283-0.672-0.031-0.943s0.675-0.281 0.943-0.031c1.047 0.979 3.885 3.616 4.429 4.045 0.289 0.228 0.339 0.647 0.111 0.937-0.131 0.165-0.328 0.251-0.524 0.251zM20.167 23.687c-0.145 0-0.293-0.048-0.417-0.144-0.904-0.724-3.449-3.016-3.833-3.432-0.249-0.271-0.231-0.693 0.040-0.94 0.272-0.251 0.693-0.235 0.943 0.037 0.309 0.336 2.801 2.584 3.684 3.293 0.288 0.229 0.335 0.648 0.105 0.937-0.131 0.163-0.327 0.248-0.521 0.248zM17.153 24.437c-0.151 0-0.304-0.052-0.429-0.159-0.868-0.732-2.063-1.924-2.861-2.779-0.251-0.268-0.236-0.692 0.033-0.943s0.692-0.235 0.943 0.032c0.771 0.827 1.917 1.972 2.745 2.671 0.281 0.237 0.316 0.657 0.080 0.94-0.132 0.156-0.32 0.237-0.511 0.237zM2.395 20.159c-0.832 0-1.443-0.052-1.868-0.153-0.303-0.073-0.513-0.344-0.511-0.653 0.045-4.845 1.3-11.797 1.353-12.089 0.064-0.356 0.397-0.593 0.757-0.54 0.173 0.028 4.283 0.668 5.975 1.259 0.288 0.101 0.473 0.383 0.445 0.687-0.303 3.468-2.672 10.6-2.773 10.901-0.084 0.251-0.307 0.427-0.569 0.451-0.061 0.007-1.472 0.139-2.809 0.139zM1.361 18.784c0.723 0.065 2.497 0.003 3.284-0.055 0.485-1.5 2.116-6.667 2.515-9.647-1.329-0.373-3.511-0.757-4.591-0.939-0.299 1.767-1.1 6.804-1.208 10.64zM29.164 19.807c-1.435 0-2.393-0.109-2.932-0.331-0.191-0.079-0.333-0.24-0.388-0.44-0.511-1.848-2.393-7.141-3.205-8.448-0.101-0.163-0.129-0.361-0.072-0.547 0.057-0.184 0.191-0.335 0.364-0.412 0.096-0.044 2.373-1.053 4.812-1.053 0.516 0 1.009 0.048 1.465 0.137 0.167 0.032 0.313 0.128 0.413 0.265 1.609 2.245 2.287 9.24 2.359 10.028 0.017 0.177-0.040 0.357-0.155 0.492-0.117 0.139-0.284 0.221-0.463 0.235-0.001 0.001-1.043 0.073-2.199 0.073zM27.027 18.325c0.333 0.072 0.967 0.149 2.139 0.149 0.531 0 1.036-0.017 1.419-0.032-0.252-2.309-0.912-6.772-1.904-8.467-0.295-0.043-0.607-0.065-0.933-0.065-1.417 0-2.805 0.401-3.596 0.679 0.937 1.939 2.339 5.939 2.876 7.736z"
              ></path>
            </svg>
          </span>
          <div
            class="status-card-title slightly-bigger-font-size font-weight-500"
            [ngClass]="
              data.client_approved ? 'solid-green-color' : 'solid-red-color'
            "
          >
            Assignment approval received
          </div>
          <div class="small-font-size pt-20">
            We are awaiting your approval for these in policy costs aligned to
            the service summary
          </div>
        </div>
        <div class="status-card col-lg-2 col-sm-6 col-12 pt-20">
          <span class="info-icon red-info-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="36"
              height="36"
              viewBox="0 0 32 32"
            >
              <path
                d="M18.656 32h-13.333c-3.464 0-5.333-3.091-5.333-6 0-0.367 0.299-0.667 0.667-0.667h12c0.368 0 0.667 0.3 0.667 0.667 0 2.268 2.741 4.667 5.333 4.667 0.367 0 0.667 0.3 0.667 0.667s-0.299 0.667-0.667 0.667zM1.363 26.667c0.247 2.044 1.616 4 3.96 4h9.4c-1.404-1.004-2.441-2.469-2.681-4h-10.679zM31.344 6.667h-6.021c-0.367 0-0.667-0.3-0.667-0.667s0.3-0.667 0.667-0.667h5.312c-0.248-2.044-1.615-4-3.959-4h-16.020c-0.368 0-0.667-0.3-0.667-0.667s0.299-0.667 0.667-0.667h16.021c3.467 0 5.333 3.091 5.333 6 0 0.367-0.299 0.667-0.667 0.667zM18.656 32c-0.367 0-0.667-0.3-0.667-0.667s0.3-0.667 0.667-0.667c2.591 0 5.333-2.399 5.333-4.667v-24.667c0-0.367 0.3-0.667 0.667-0.667s0.667 0.3 0.667 0.667v24.667c0 3.028-3.301 6-6.667 6zM7.323 26c-0.368 0-0.667-0.3-0.667-0.667v-21.333c0-0.367 0.299-0.667 0.667-0.667s0.667 0.3 0.667 0.667v21.333c0 0.367-0.299 0.667-0.667 0.667zM7.323 4.667c-0.368 0-0.667-0.3-0.667-0.667 0-2.205 1.795-4 4-4 0.368 0 0.667 0.3 0.667 0.667s-0.299 0.667-0.667 0.667c-1.471 0-2.667 1.195-2.667 2.667 0 0.367-0.299 0.667-0.667 0.667zM21.323 9.333h-10.667c-0.368 0-0.667-0.3-0.667-0.667s0.299-0.667 0.667-0.667h10.667c0.367 0 0.667 0.3 0.667 0.667s-0.299 0.667-0.667 0.667zM21.323 13.333h-10.667c-0.368 0-0.667-0.3-0.667-0.667s0.299-0.667 0.667-0.667h10.667c0.367 0 0.667 0.3 0.667 0.667s-0.299 0.667-0.667 0.667zM21.323 17.333h-10.667c-0.368 0-0.667-0.3-0.667-0.667s0.299-0.667 0.667-0.667h10.667c0.367 0 0.667 0.3 0.667 0.667s-0.299 0.667-0.667 0.667z"
              ></path>
            </svg>
          </span>
          <div
            class="status-card-title slightly-bigger-font-size font-weight-500 solid-red-color"
          >
            Assignment additional scope approval received
          </div>
          <div class="small-font-size pt-20">
            Examples of additional services & costs which we may need to seek
            additional approval for
          </div>
        </div>
      </div>
    </div>
    <div class="divider"></div>
    <div class="divider blue-background"></div>
    <!--    K2 Recommendation -->
    <div
      id="k2-recommendation"
      class="row justify-content-center blue-background"
    >
      <div class="col-10">
        <div
          class="d-flex flex-lg-row flex-column col-12 justify-content-between column-gap-2p"
        >
          <div
            id="trusted-partner"
            class="d-flex col-lg-6 col-md-12 item overflow-hidden blue-background"
          >
            <div class="d-block">
              <div
                [@fromBottom]="animateDiv['trusted-partner'][0]"
                class="approval-header large-font-size font-weight-100 col-12 mb-10"
              >
                <div
                  class="info-icon blue-number-icon col-12 position-relative z-2"
                >
                  <div
                    class="extra-large-font-size font-weight-700 fst-italic d-flex justify-content-center position-relative z-3"
                  >
                    1
                  </div>
                </div>
                <div class="mt-n6">K2’s trusted partner of choice</div>
              </div>
              <div
                [@fromBottom]="animateDiv['trusted-partner'][1]"
                class="col-12"
              >
                <div class="approval-header-subtext regular-font-size">
                  This moving cost estimate has been created and specifically
                  tailored for
                  <strong>{{ data.assignee_full_name }}</strong> from
                  <strong
                    >{{ data.origin_city }} ({{
                      data.origin_country_iso2
                    }})</strong
                  >
                  to
                  <strong
                    >{{ data.destination_city }} ({{
                      data.destination_country_iso2
                    }})</strong
                  >
                  requirements, to ensure a smooth and disruption free moving
                  experience. In addition to this, it also includes K2 Clear
                  insurance (excluding high value items)
                </div>
                <div
                  class="col-12 d-flex align-items-center border-top px-0 pt-20 pb-20"
                >
                  <div class="font-weight-500 col-6 ps-0">
                    Trusted partner of choice
                  </div>
                  <div class="col-6 small-font-size ps-0">
                    {{ data.selectedVendorName }}
                  </div>
                </div>
                @if (!!data.selectedVendorTotal) {
                <div
                  class="col-12 d-flex align-items-center border-top px-0 pt-20 pb-20"
                >
                  <div class="font-weight-500 col-6 ps-0">
                    Cost summary
                    {{
                      !!data.selectedVendorBundleTotals?.length
                        ? '&nbsp;Transits'
                        : ''
                    }}
                  </div>
                  <div
                    class="font-weight-200 slightly-bigger-font-size fst-italic col-6 ps-0"
                  >
                    {{ currencySymbol }}{{ data.selectedVendorTotal }}
                  </div>
                </div>
                } @for (bundle of data.selectedVendorBundleTotals; track bundle;
                let i = $index) {
                <div
                  class="col-12 d-flex align-items-center border-top px-0 pt-20 pb-20"
                >
                  <div class="font-weight-500 col-6 ps-0">
                    Cost summary {{ bundle.bundle_name }}
                  </div>
                  <div
                    class="font-weight-200 slightly-bigger-font-size fst-italic col-6 ps-0"
                  >
                    {{ currencySymbol }}{{ bundle.total }}
                  </div>
                </div>
                } @if
                (!!data.comparison_tables.comparison.specialist_services_total)
                {
                <div
                  class="col-12 d-flex align-items-center border-top px-0 pt-20 pb-20"
                >
                  <div class="font-weight-500 col-6 ps-0">
                    Cost summary Specialist Services
                  </div>
                  <div
                    class="font-weight-200 slightly-bigger-font-size fst-italic col-6 ps-0"
                  >
                    {{ currencySymbol
                    }}{{
                      data.comparison_tables.comparison
                        .specialist_services_total
                    }}
                  </div>
                </div>
                } @if (!data.comparison_tables.comparison.bundles.length &&
                data.comparison_tables.comparison.specialist_services_total &&
                data.comparison_tables.comparison.offerTotals) {
                <div
                  class="col-12 d-flex align-items-center border-top px-0 pt-20 pb-20"
                >
                  <div class="font-weight-500 col-6 ps-0">Total</div>
                  <div
                    class="font-weight-200 slightly-bigger-font-size fst-italic col-6 ps-0"
                  >
                    {{ currencySymbol
                    }}{{
                      data.comparison_tables.comparison.offerTotals[
                        data.selected_quote_id
                      ]
                    }}
                  </div>
                </div>
                }
              </div>
              <div class="col-sm-4 col-10"></div>
            </div>
          </div>
          <div class="d-lg-none divider blue-background"></div>
          <div
            id="approval"
            class="col-lg-6 col-md-12 item overflow-hidden blue-background"
          >
            <div
              [@fromBottom]="animateDiv['approval'][0]"
              class="approval-header large-font-size font-weight-100 col-12 mb-10"
            >
              <div
                class="info-icon blue-number-icon col-12 position-relative z-2"
              >
                <div
                  class="extra-large-font-size font-weight-700 fst-italic d-flex justify-content-center position-relative z-3"
                >
                  2
                </div>
              </div>
              <div class="mt-n6">
                Take a moment, we want to get it right first time
              </div>
            </div>
            <div [@fromBottom]="animateDiv['approval'][1]" class="row col-12">
              <div class="approval-header-subtext col-12">
                <div class="regular-font-size font-weight-700">
                  Please ensure invoicing details are correct
                </div>
                <div class="regular-font-size">
                  To ensure everything goes smoothly on the billing side of
                  things, we have noted what we know about the details we have
                  aligned with your policy. Please let us know if any of these
                  details are incorrect.
                </div>
              </div>
              <div class="col-12">
                <div class="pb-20 pt-20 row border-top ms-0">
                  <div class="font-weight-500 col-5 pe-0">Invoice address</div>
                  <div class="col-7 small-font-size">
                    {{ data.confirm_billing_information.address }}
                  </div>
                </div>
                <!--          <div class="align-items-center pb-20 pt-20 row light-border-bottom ms-0">-->
                <!--            <div class="col-5 pe-0">Email:</div>-->
                <!--            <div class="col-7 small-font-size font-weight-300">{{ data.confirm_billing_information.email }}</div>-->
                <!--          </div>-->
                @if (data.confirm_billing_information.phone) {
                <div class="pb-20 pt-20 row light-border-bottom ms-0">
                  <div class="font-weight-500 col-5 pe-0">Phone:</div>
                  <div class="col-7 small-font-size">
                    {{ data.confirm_billing_information.phone }}
                  </div>
                </div>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="d-lg-none divider blue-background"></div>
        <div
          id="approve-costs-button"
          class="col-12 item overflow-hidden blue-background"
        >
          @if (!data.client_approved) {
          <div
            [@fromBottom]="animateDiv['approve-costs-button'][0]"
            class="d-flex align-items-center item pt-20 mb-30"
          >
            <div
              class="d-inline-block info-icon blue-number-icon position-relative z-2"
            >
              <div
                class="extra-large-font-size font-weight-700 fst-italic d-flex justify-content-center position-relative z-3"
              >
                3
              </div>
            </div>
            <div
              (click)="onApproveClick()"
              class="d-flex align-items-center navigation-btn-inverted click-approve-btn font-weight-500 position-relative z-4 m-0"
              [class.loading]="approving"
            >
              Click to approve these costs
              <div class="btn-icon"><i class="fa fa-check"></i></div>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
    <div class="divider blue-background"></div>
    <div class="divider"></div>
    <!--    Overview-->
    <div id="overview" class="row item overflow-hidden">
      <div
        class="large-font-size font-weight-100 darker-grey-color col-10 mb-20"
        [@fromBottom]="animateDiv.overview[0]"
      >
        Overview
      </div>
      <div class="row col-10 p-0" [@fromBottom]="animateDiv.overview[1]">
        <div class="col-12 mb-30">
          <div class="font-weight-600 big-font-size darker-grey-color pt-10">
            Assignment needs & requirements
          </div>
          <div class="small-font-size darker-grey-color pt-10">
            <span class="font-weight-300"
              >The move requirements have been discussed in detail with
            </span>
            <strong>{{ data.assignee_full_name }}</strong>
            <span class="font-weight-300"
              >. The below information and MCE, reflects their exact relocation
              and transit insurance requirements as per your Global Mobility
              policy. The MCE is valid for 30 days.</span
            >
          </div>
        </div>
        <div class="col-sm-2"></div>
        <div class="assignment-details-table col-12 blue-color">
          <div class="font-weight-700 big-font-size pt-20 pb-20">
            Here’s what we know about you & the assignee
          </div>
          <div class="row item justify-content-center">
            <div class="table-column col-lg-4 col-md-12">
              <div
                class="table-white-row table-row justify-content-between align-items-center px-5 pb-20 pt-20 row blue-border-top blue-border-bottom ms-0"
              >
                <div class="font-weight-500 pe-0">Client name:</div>
                <div class="small-font-size">{{ data.client_name }}</div>
              </div>
              <div
                class="table-white-row table-row justify-content-between align-items-center px-5 pb-20 pt-20 row ms-0"
              >
                <div class="font-weight-500 pe-0">Assignee name:</div>
                <div class="small-font-size">{{ data.assignee_full_name }}</div>
              </div>
            </div>
            <div class="table-column col-lg-4 col-md-12">
              <div
                class="table-white-row table-row justify-content-between align-items-center px-5 pb-20 pt-20 row blue-border-top blue-border-bottom ms-0"
              >
                <div class="font-weight-500 pe-0">K2 unique reference:</div>
                <div class="small-font-size">{{ data.k2_id }}</div>
              </div>
              <div
                class="table-white-row table-row justify-content-between align-items-center px-5 pb-20 pt-20 row ms-0"
              >
                <div class="font-weight-500 pe-0">Current location:</div>
                <div class="small-font-size">
                  {{ data.origin_city }} ({{ data.origin_country_iso2 }})
                </div>
              </div>
            </div>
            <div class="table-column col-lg-4 col-md-12">
              <div
                class="table-white-row table-row justify-content-between align-items-center px-5 pb-20 pt-20 row blue-border-top blue-border-bottom ms-0"
              >
                <div class="font-weight-500 pe-0">Destination:</div>
                <div class="small-font-size">
                  {{ data.destination_city }} ({{
                    data.destination_country_iso2
                  }})
                </div>
              </div>
              <div
                class="table-row table-white-row justify-content-between align-items-center px-5 pb-20 pt-20 row blue-border-bottom ms-0"
              >
                <div class="font-weight-500 pe-0">Within policy:</div>
                <div class="small-font-size">
                  {{ data.policy_data?.policy ? 'Yes' : 'No' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="divider"></div>
    <!--    Recommendation & Summary-->
    <div id="recommendations" class="row item solid-green-color">
      <div id="summary-relocating" class="col-10 mb-30">
        <div [@fromBottom]="animateDiv['summary-relocating'][0]">
          <div class="font-weight-700 big-font-size pb-20">
            Here is a summary of exactly what we are moving
          </div>
          <div class="small-font-size pb-20">
            Here is a tailored summary of exactly what we are moving, to
            relocate
            <strong>{{ data.assignee_full_name }}</strong> from
            <strong
              >{{ data.origin_city }} ({{ data.origin_country_iso2 }})</strong
            >
            to
            <strong
              >{{ data.destination_city }} ({{
                data.destination_country_iso2
              }})</strong
            >, please note that forwarding of the shipment can only proceed when
            all immigration, export and import customs and government
            formalities have been approved by your K2 client service team.
          </div>
          <div
            class="font-weight-500 align-items-center pb-20 row green-border-bottom ms-0"
          >
            <div class="col-sm-3 ps-0 pt-20">Transit method</div>
            <div class="col-sm-3 ps-0 pt-20">Origin > Destination</div>
            <div class="col-sm-3 ps-0 pt-20">
              {{ data.survey_measurement_label }}
            </div>
            <div class="col-sm-3 ps-0 pt-20">Container size</div>
          </div>
          @for (transit of data.transits_overview; track transit) {
          <div
            class="table-row table-green-row align-items-center pb-20 row green-border-bottom ms-0"
            (click)="scrollTo('relocation-details')"
          >
            <div
              class="col-sm-3 small-font-size font-weight-400 pt-20 d-flex align-items-center"
            >
              <div class="transit-icon me-3">
                <ng-container
                  *ngTemplateOutlet="
                    transitIcon;
                    context: { $implicit: transit.transit_type }
                  "
                ></ng-container>
              </div>
              {{ transit.transit_method }}
            </div>
            <div class="col-sm-3 small-font-size font-weight-300 pt-20">
              {{ transit.origin.city }} ({{ transit.origin.iso2 }}) >
              {{ transit.destination.city }} ({{ transit.destination.iso2 }})
            </div>
            <div class="col-sm-3 small-font-size font-weight-300 pt-20">
              {{ transit.measurement_total }}
            </div>
            <div class="col-sm-3 small-font-size font-weight-300 pt-20">
              {{ transit.container }}
            </div>
          </div>
          }
        </div>
      </div>
    </div>
    <div class="small-divider dark-grey-item"></div>
    <!--    Trusted partner & cost comparison summary-->
    <div class="small-divider grey-item"></div>
    <div
      id="comparison-summary"
      class="row item grey-item darker-grey-color overflow-hidden"
    >
      <div class="col-10 pb-20">
        <div class="font-weight-100 large-font-size mb-30">
          Trusted partner & cost comparison summary
        </div>
        <div class="font-weight-700">
          Based upon our experience we would recommend
          <span class="blue-color">{{ data.selectedVendorName }}</span> as our
          trusted partner for your moving service.
        </div>
        <div class="small-font-size">
          If you would like to consider one of the alternative suppliers noted
          below, do not hesitate to let us know and we will be very happy to
          engage.
        </div>
      </div>
      <!--      bundles -->
      @for (bundle of data.comparison_tables.comparison.bundles; track bundle) {
      <div class="col-10 px-0">
        <div class="col-12 font-weight-700 text-start">{{ bundle.name }}</div>
        <div class="col-12 text-start">{{ bundle.description }}</div>
        <!-- Trusted K2 partner -->
        <div class="col-12 pt-20">
          <div class="row quote-item justify-content-between selected-quote">
            <div class="col-md-12 col-lg-5">
              <div class="d-flex regular-font-size pt-20 pb-20">
                <div
                  class="d-flex align-items-center info-badge navigation-btn-inverted white-background blue-color"
                >
                  Trusted K2 partner
                  <div class="btn-icon"><i class="fa fa-check"></i></div>
                </div>
              </div>
              <div class="extra-big-font-size font-weight-300">
                {{ selectedQuotesByBundleMap[bundle.id].quote_label }}
              </div>
              <div class="quote-total extra-large-font-size pb-md-4">
                {{ currencySymbol
                }}{{ selectedQuotesByBundleMap[bundle.id].bundle_total }}
              </div>
            </div>
            <div
              class="quoted-items-table row item justify-content-lg-between justify-content-md-end col-md-12 col-lg-7 px-lg-5 px-3"
            >
              @for (item of
              quotedItemsByBundleByVendorMap[bundle.id][selectedQuotesByBundleMap[bundle.id].quote_id];
              track item) { @if (item.amount != 0) {
              <div
                class="quoted-items-table-cell row item justify-content-between align-items-center col-md-12 col-xl-6 white-border-bottom"
              >
                <div
                  class="col-12 col-sm-7 col-xl-6 d-flex justify-content-start font-weight-500 ps-0 pe-1 py-4"
                >
                  {{ item.label }}
                </div>
                <div
                  class="col-12 col-sm-5 col-xl-6 d-flex flex-wrap justify-content-between font-weight-500 px-0 py-4"
                >
                  <div class="me-2">{{ currencySymbol }}</div>
                  <div>{{ item.amount }}</div>
                </div>
              </div>
              } }
            </div>
          </div>
          <div class="mb-30"></div>
        </div>
        <!-- Other quotes-->
        @for (quote of bundle.quotes | keyvalue; track quote) {
        <div class="col-12 pt-20">
          @if (quote.value.quote_id !==
          selectedQuotesByBundleMap[bundle.id].quote_id) {
          <div class="row quote-item justify-content-between">
            <div class="col-md-12 col-lg-5">
              <div class="extra-big-font-size font-weight-300">
                {{ quote.value.quote_label }}
              </div>
              <div class="quote-total extra-large-font-size pb-md-4">
                {{ currencySymbol }}{{ quote.value.bundle_total }}
              </div>
            </div>
            <div
              class="quoted-items-table row item justify-content-lg-between justify-content-md-end col-md-12 col-lg-7 px-lg-5 px-3"
            >
              @for (item of
              quotedItemsByBundleByVendorMap[bundle.id][quote.value.quote_id];
              track item) { @if (item.amount != 0) {
              <div
                class="quoted-items-table-cell row item justify-content-between align-items-center col-md-12 col-xl-6 white-border-bottom"
              >
                <div
                  class="col-12 col-sm-7 col-xl-6 d-flex justify-content-start font-weight-500 ps-0 pe-1 py-4"
                >
                  {{ item.label }}
                </div>
                <div
                  class="col-12 col-sm-5 col-xl-6 d-flex flex-wrap justify-content-between font-weight-500 px-0 py-4"
                >
                  <div class="me-2">{{ currencySymbol }}</div>
                  <div>{{ item.amount }}</div>
                </div>
              </div>
              } }
            </div>
          </div>
          }
          <div class="mb-30"></div>
        </div>
        }
      </div>
      }
      <!--      simple transits -->
      @if (data.comparison_tables.comparison.totals) {
      <div class="col-10 px-0">
        @if (data.comparison_tables.comparison.bundles.length) {
        <div class="col-12 font-weight-700 text-start">Transits</div>
        }
        <!-- Trusted partner-->
        <div class="col-12 pt-20">
          <div class="row quote-item justify-content-between selected-quote">
            <div class="col-md-12 col-lg-5">
              <div class="d-flex regular-font-size pt-20 pb-20">
                <div
                  class="d-flex align-items-center info-badge navigation-btn-inverted white-background blue-color"
                >
                  Trusted K2 partner
                  <div class="btn-icon"><i class="fa fa-check"></i></div>
                </div>
              </div>
              <div class="extra-big-font-size font-weight-300">
                {{ selectedQuote.quote_label }}
              </div>
              <div class="quote-total extra-large-font-size pb-md-4">
                {{ currencySymbol }}{{ selectedQuote.quote_total }}
              </div>
            </div>
            <div
              class="quoted-items-table row item justify-content-lg-between justify-content-md-end col-md-12 col-lg-7 px-lg-5 px-3"
            >
              @for (item of quotedItemsByVendorMap[selectedQuote.quote_id];
              track item) { @if (item.amount != 0) {
              <div
                class="quoted-items-table-cell row item justify-content-between align-items-center col-md-12 col-xl-6 white-border-bottom"
              >
                <div
                  class="col-12 col-sm-7 col-xl-6 d-flex justify-content-start font-weight-500 ps-0 pe-1 py-4"
                >
                  {{ item.label }}
                </div>
                <div
                  class="col-12 col-sm-5 col-xl-6 d-flex flex-wrap justify-content-between font-weight-500 px-0 py-4"
                >
                  <div class="me-2">{{ currencySymbol }}</div>
                  <div>{{ item.amount }}</div>
                </div>
              </div>
              } }
            </div>
          </div>
          <div class="mb-30"></div>
        </div>
        <!-- Other quotes-->
        @for (quote of data.comparison_tables.comparison.totals; track quote;
        let i = $index) {
        <div class="col-12 pt-20">
          @if (quote.quote_id !== selectedQuote.quote_id) {
          <div class="row quote-item justify-content-between">
            <div class="col-md-12 col-lg-5">
              <div class="extra-big-font-size font-weight-300">
                {{ quote.quote_label }}
              </div>
              <div class="quote-total extra-large-font-size pb-md-4">
                {{ currencySymbol
                }}{{ data.comparison_tables.comparison.totals[i].quote_total }}
              </div>
            </div>
            <div
              class="quoted-items-table row item justify-content-lg-between justify-content-md-end col-md-12 col-lg-7 px-lg-5 px-3"
            >
              @for (item of quotedItemsByVendorMap[quote.quote_id]; track item)
              { @if (item.amount != 0) {
              <div
                class="quoted-items-table-cell row item justify-content-between align-items-center col-md-12 col-xl-6 white-border-bottom"
              >
                <div
                  class="col-12 col-sm-7 col-xl-6 d-flex justify-content-start font-weight-500 ps-0 pe-1 py-4"
                >
                  {{ item.label }}
                </div>
                <div
                  class="col-12 col-sm-5 col-xl-6 d-flex flex-wrap justify-content-between font-weight-500 px-0 py-4"
                >
                  <div class="me-2">{{ currencySymbol }}</div>
                  <div>{{ item.amount }}</div>
                </div>
              </div>
              } }
            </div>
          </div>
          }
          <div class="mb-30"></div>
        </div>
        }
      </div>
      } @if (!data.comparison_tables.comparison.bundles.length &&
      data.comparison_tables.comparison.specialist_services_total &&
      data.comparison_tables.comparison.offerTotals) {
      <div class="col-10 px-0">
        <div class="col-12 font-weight-700 text-start">Partner totals</div>
        <!-- Trusted K2 Partner -->
        <div class="col-12 pt-20">
          <div class="row quote-item justify-content-between selected-quote">
            <div class="col-12">
              <div class="d-flex regular-font-size pt-20 pb-20">
                <div
                  class="d-flex align-items-center info-badge navigation-btn-inverted white-background blue-color"
                >
                  Trusted K2 partner
                  <div class="btn-icon"><i class="fa fa-check"></i></div>
                </div>
              </div>
            </div>
            <div
              class="quoted-items-table row item justify-content-lg-between justify-content-md-end col-12 px-lg-5 px-3"
            >
              <div class="extra-big-font-size font-weight-300 col-12 col-md-6">
                {{ selectedQuote.quote_label }}
              </div>
              <div class="extra-big-font-size font-weight-300 col-12 col-md-6">
                {{ currencySymbol
                }}{{
                  data.comparison_tables.comparison.offerTotals[
                    selectedQuote.quote_id
                  ]
                }}
              </div>
            </div>
          </div>
          <div class="mb-30"></div>
        </div>
        <!-- Other partners -->
        @for (quote of quoteIdVendorCollection; track quote) {
        <div class="col-12 pt-20">
          @if (quote.quoteId !== selectedQuote.quote_id) {
          <div class="row quote-item justify-content-between">
            <div
              class="quoted-items-table row item justify-content-lg-between justify-content-md-end col-12 px-lg-5 px-3"
            >
              <div class="extra-big-font-size font-weight-300 col-12 col-md-6">
                {{ quote.vendorName }}
              </div>
              <div class="extra-big-font-size font-weight-300 col-12 col-md-6">
                {{ currencySymbol }}{{ quote.total }}
              </div>
            </div>
          </div>
          }
        </div>
        }
      </div>
      }
      <div class="col-10 grey-color small-font-size">
        <strong>Costs not included:</strong> We aim to capture all cost and
        service requirements to ensure a smooth moving and relocation experience
        from {{ data.origin_city }} to {{ data.destination_city }}. However,
        there may be additional costs that vary on a case-by-case basis, such as
        insurance, customs duties, taxes, and other fees. We will inform you in
        advance and provide supporting documentation for any necessary
        approvals. Rest assured, your dedicated account manager will guide you
        through the process. Sales Tax is not included in values shown.
      </div>
      <div class="col-10 grey-color small-font-size pt-20">
        <strong>Note:</strong> K2 Clear is a product specifically built for K2
        customers and removes the need for clients to complete an individual
        valued inventory, but they are required to declare high value items
        exceeding GBP 1,000 / EUR 1,300 / USD 1,500 / AUD 2,000. Alternatively
        K2 customers can complete a valued inventory where desired. The K2 Clear
        policy excludes watches, jewellery, furs, documents, and securities.
      </div>
      @if (data.additional_information) {
      <div class="col-10 grey-color small-font-size pt-20">
        <strong>Additional notes:</strong> {{ data.additional_information }}
      </div>
      }
      <div class="col-10 pt-20 mb-30" id="further-costs">
        @if (data.specialist_services.length) {
        <div
          [@fromBottom]="animateDiv['further-costs'][0]"
          class="big-font-size font-weight-600 pt-20"
        >
          Specialist trade & home making services
        </div>
        } @for (location of data.specialist_services | keyvalue; track location)
        {
        <div
          [@fromBottom]="animateDiv['further-costs'][0]"
          class="font-weight-500 pb-20 pt-20"
        >
          Third party services required in
          <strong>{{ location.value.location_city }}</strong>
        </div>
        <div
          [@fromBottom]="animateDiv['further-costs'][1]"
          class="align-items-center pb-20 row dark-border-bottom ms-5"
        >
          <div class="d-none d-sm-inline col-sm-3 ps-0 pt-20">
            <ng-container
              *ngTemplateOutlet="
                transitIcon;
                context: { $implicit: 'special_items' }
              "
            ></ng-container>
            <span class="ms-3">Service required</span>
          </div>
          <div class="d-none d-sm-inline col-sm-3 ps-0 pt-20">Scope</div>
          <div class="d-none d-sm-inline col-sm-3 ps-0 pt-20">To carry out</div>
          <div class="d-none d-sm-inline col-sm-3 ps-0 pt-20">Cost</div>
        </div>
        @for (service of location.value.services; track service) {
        <div
          [@fromBottom]="animateDiv['further-costs'][1]"
          class="table-row table-blue-row align-items-center pb-20 row dark-border-bottom ms-5"
        >
          <div class="col-6 d-sm-none small-font-size font-weight-500 pt-20">
            Service required:
          </div>
          <div class="col-6 col-sm-3 small-font-size font-weight-300 pt-20">
            {{ service.service_name }}
          </div>
          <div class="col-6 d-sm-none small-font-size font-weight-500 pt-20">
            Scope:
          </div>
          <div class="col-6 col-sm-3 small-font-size font-weight-300 pt-20">
            {{ service.scope }}
          </div>
          <div class="col-6 d-sm-none small-font-size font-weight-500 pt-20">
            To carry out:
          </div>
          <div class="col-6 col-sm-3 small-font-size font-weight-300 pt-20">
            {{ service.description || '-' }}
          </div>
          <div class="col-6 d-sm-none small-font-size font-weight-500 pt-20">
            Cost:
          </div>
          <div class="col-6 col-sm-3 small-font-size font-weight-300 pt-20">
            {{ service.quote }}
          </div>
        </div>
        } } @if (data.comparison_tables.comparison.specialist_services_total) {
        <div
          [@fromBottom]="animateDiv['further-costs'][1]"
          class="table-row table-blue-row align-items-center pb-20 row ms-0"
        >
          <div class="col-6 col-sm-4 font-weight-500 pb-20 pt-20">
            Third party services total
          </div>
          <div class="col-sm-5 d-none d-sm-inline"></div>
          <div class="col-6 col-sm-3 font-weight-500 pb-20 pt-20">
            <strong>
              {{ currencySymbol
              }}{{
                data.comparison_tables.comparison.specialist_services_total
              }}
            </strong>
          </div>
        </div>
        }
      </div>
      <!--      <div *ngIf="storageItems.length" id="storage-costs" class="col-10 pt-20 mb-30 blue-color">-->
      <!--        <div [@fromBottom]="animateDiv['storage-costs'][0]" class="font-weight-600 big-font-size pt-20 pb-20">-->
      <!--          Ongoing storage costs-->
      <!--        </div>-->
      <!--        <div [@fromBottom]="animateDiv['storage-costs'][0]" class="small-font-size font-weight-300 pb-20">-->
      <!--          Proin at quam lacinia, venenatis mauris in, fringilla dui. Ut commodo non odio non lacinia. Proin fermentum-->
      <!--          nulla at quam vulputate, nec bibendum magna congue. In condimentum lectus mi, sed pellentesque orci tincidunt-->
      <!--          placerat. Vivamus a enim sed enim condimentum ultricies fringilla id ipsum. Vestibulum gravida ex elementum,-->
      <!--          ornare lorem non, rutrum est. Ut quis dignissim ante.-->
      <!--        </div>-->
      <!--        <div [@fromBottom]="animateDiv['storage-costs'][1]"-->
      <!--             class="align-items-center pb-20 row dark-border-bottom ms-0">-->
      <!--          <div class="col-sm-3 ps-0 pt-20">Number</div>-->
      <!--          <div class="col-sm-3 ps-0 pt-20">Description</div>-->
      <!--          <div class="col-sm-3 ps-0 pt-20">Cost</div>-->
      <!--        </div>-->
      <!--        <div [@fromBottom]="animateDiv['storage-costs'][1]" *ngFor="let item of storageItems; index as i"-->
      <!--             class="table-row table-blue-row align-items-center pb-20 row dark-border-bottom ms-0">-->
      <!--          <div class="col-sm-3 small-font-size font-weight-300 pt-20">{{ i }}</div>-->
      <!--          <div class="col-sm-3 small-font-size font-weight-300 pt-20">{{ item.description }}</div>-->
      <!--          <div class="col-sm-3 small-font-size font-weight-300 pt-20">{{ item.cost }}</div>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div *ngIf="additionalItems.length" id="scope-items" class="col-10 pt-20 mb-30 red-color">-->
      <!--        <div [@fromBottom]="animateDiv['scope-items'][0]" class="font-weight-600 big-font-size pt-20 pb-20">-->
      <!--          Additional scope items-->
      <!--        </div>-->
      <!--        <div [@fromBottom]="animateDiv['scope-items'][0]" class="small-font-size font-weight-300 pb-20">-->
      <!--          Lorem ipsum dolor sit amet, consectetur adipiscing elit. In cursus ipsum sit amet sem commodo varius sit amet-->
      <!--          in magna. Etiam tempor commodo viverra. Fusce elit quam, tempor nec interdum vel, ornare eget velit. Proin at-->
      <!--          quam lacinia, venenatis mauris in, fringilla dui. Ut commodo non odio non lacinia. Proin fermentum nulla at-->
      <!--          quam vulputate, nec bibendum magna congue. In condimentum lectus mi, sed pellentesque orci tincidunt placerat.-->
      <!--          Vivamus a enim sed enim condimentum ultricies fringilla id ipsum. Vestibulum gravida ex elementum, ornare-->
      <!--          lorem non, rutrum est. Ut quis dignissim ante.-->
      <!--        </div>-->
      <!--        <div [@fromBottom]="animateDiv['scope-items'][1]" class="align-items-center pb-20 row dark-border-bottom ms-0">-->
      <!--          <div class="col-sm-3 ps-0 pt-20">Number</div>-->
      <!--          <div class="col-sm-3 ps-0 pt-20">Description</div>-->
      <!--          <div class="col-sm-3 ps-0 pt-20">Cost</div>-->
      <!--        </div>-->
      <!--        <div *ngFor="let item of additionalItems; index as i" [@fromBottom]="animateDiv['scope-items'][1]"-->
      <!--             class="table-row table-red-row align-items-center pb-20 row dark-border-bottom ms-0">-->
      <!--          <div class="col-sm-3 small-font-size font-weight-300 pt-20">{{ i }}</div>-->
      <!--          <div class="col-sm-3 small-font-size font-weight-300 pt-20">{{ item.description }}</div>-->
      <!--          <div class="col-sm-3 small-font-size font-weight-300 pt-20">{{ item.cost }}</div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <div class="small-divider grey-item"></div>
    <div class="divider white-background"></div>
    <!--    Move details-->
    <div id="move-details" class="row item white-background">
      <div class="col-10 darker-grey-color">
        <div class="large-font-size font-weight-100 mb-30">Move details</div>
        @for (transit of data.transits_overview; track transit; let i = $index)
        {
        <div
          class="toggle-container pt-30"
          [ngClass]="openedTransitTextIndex === i ? 'opened' : ''"
        >
          <div
            class="blue-background font-weight-600 pt-20 pb-20 white toggle-title"
            (click)="onToggleClick(i)"
          >
            <div class="big-font-size font-weight-700">
              {{ transit.transit_label }}
            </div>
            <div
              class="d-flex justify-content-center align-items-center icon-container light-blue-background"
            >
              <i
                class="d-flex fa"
                [ngClass]="
                  openedTransitTextIndex === i ? 'fa-times' : 'fa-arrow-down'
                "
              ></i>
            </div>
          </div>
          <div
            class="toggle-context"
            [@collapse]="openedTransitTextIndex !== i"
            [innerHTML]="transit.transit_text"
          ></div>
        </div>
        }
      </div>
    </div>
    <div class="divider white-background"></div>
    <!-- About K2-->
    <div class="divider black-background"></div>
    <div id="about-k2" class="row item black-background">
      <div
        class="large-font-size font-weight-100 col-12 text-center align-items-center pb-30"
      >
        K2 Insights
      </div>
      <div class="row item justify-content-lg-between align-items-start col-10">
        @for (data of aboutK2Data; track data) {
        <div
          class="card d-flex flex-column item black-background col-md-12 col-lg-3 border-0 pb-50"
        >
          <div class="about-k2-img-container align-self-center">
            <img
              class="card-img-top about-k2-img"
              src="bid-summary/{{ data.img }}"
              [alt]="data.imgAlt"
              [style]="data?.style"
            />
          </div>
          <div
            class="card-body d-flex flex-column justify-content-between pt-20"
          >
            <div class="card-text d-flex flex-column justify-content-between">
              <div
                class="card-title-font-size font-weight-400 text-center text-lg-start pb-20 justify-content-start"
                [innerHTML]="data.title"
              ></div>
              <div
                class="font-weight-700 text-center text-lg-start pb-30"
                [innerHTML]="data.subTitle"
              ></div>
              <div
                class="last-text font-weight-400 text-justify text-lg-start pb-30"
                [innerHTML]="data.boldText"
              ></div>
            </div>
            <a
              class="navigation-btn small-font-size d-flex align-self-center align-self-lg-start align-items-center btn-primary mt-10"
              [href]="data.link"
              target="_blank"
            >
              {{ data.linkText }}
              <div class="btn-icon"><i class="fa fa-external-link"></i></div>
            </a>
          </div>
        </div>
        }
      </div>
    </div>
    <div class="divider black-background"></div>
    <!-- Thank you-->
    <div class="small-divider blue-background"></div>
    <div id="assignment-lead" class="row item overflow-hidden blue-background">
      <div
        class="col-10 align-items-center justify-content-center flex-wrap"
        [class.row]="data.assignment_lead_information.logo"
      >
        <div class="row">
          <div class="col-12 d-flex flex-wrap align-items-center">
            @if (data.assignment_lead_information.logo) {
            <div class="pt-20">
              <div class="assignment-lead-img">
                <img
                  src="data:image/png;base64,{{
                    data.assignment_lead_information.logo
                  }}"
                  alt="Assignment Lead"
                />
              </div>
            </div>
            }
            <div
              class="assignment-lead-info pt-20"
              [class.without-logo]="!data.assignment_lead_information.logo"
            >
              <div
                class="large-font-size thank-you-text"
                [@fromBottom]="animateDiv['assignment-lead'][0]"
              >
                Thank you
              </div>
              <div
                class="small-font-size font-weight-300 pb-20"
                [@fromBottom]="animateDiv['assignment-lead'][0]"
              >
                I hope you found this document helpful. If you would like to
                proceed you can
                <span
                  class="cursor-pointer text-underline"
                  (click)="scrollTo('approval')"
                  >click here</span
                >
                to return to the approval section and myself and the team will
                take care of everything for you. If you have any questions
                whatsoever, do not hesitate to contact me by calling, messaging
                or emailing me and I will be happy to help.
              </div>
              <div
                [@fromBottom]="animateDiv['assignment-lead'][0]"
                class="big-font-size font-weight-300"
              >
                {{ data.assignment_lead_information.full_name }}
              </div>
              <div
                [@fromBottom]="animateDiv['assignment-lead'][0]"
                class="small-font-size font-weight-600 pb-20"
              >
                {{ data.assignment_lead_information.job_title }}
              </div>
              @if (data.assignment_lead_information.mobile) {
              <div
                [@fromBottom]="animateDiv['assignment-lead'][0]"
                class="small-font-size font-weight-300"
              >
                {{ data.assignment_lead_information.mobile }}
              </div>
              }
              <div
                [@fromBottom]="animateDiv['assignment-lead'][0]"
                class="small-font-size font-weight-300"
              >
                {{ data.assignment_lead_information.office_address }}
              </div>
              <a
                [@fromBottom]="animateDiv['assignment-lead'][0]"
                class="small-font-size underlined-link font-weight-300"
                href="mailto:{{ data.assignment_lead_information.email }}"
              >
                {{ data.assignment_lead_information.email }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="divider blue-background"></div>
    <!-- Terms and conditions-->
    <div class="small-divider black-background"></div>
    <div id="terms-and-conditions" class="row item black-background white">
      <div class="col-10 justify-content-center">
        <div class="font-weight-700 col-12 pb-20">Terms & conditions</div>
        <div class="small-font-size col-12 pb-20">
          Prices exclude local VAT/GST where applicable, customs duties, import
          taxes, Government levies, x-ray fees, customs inspections, demurrage,
          port/airline storage charges, warehouse handling, storage charges,
          long carry, external lifting equipment, heavy item handling, difficult
          access, shuttle service, split deliveries, weekend or statutory
          holiday surcharges, out of hours work, any additional per diem, high
          value item insurance, elevator access, delivery to 2nd floor and over
          at destination, access restriction requirements not known at the time
          of quoting or volume/weight variations post survey resulting in cost
          changes. Freight rate charges are outside of our control and will
          apply as per the current month’s market conditions. Where necessary,
          K2 will pre-advise on the above costs and provide rationale behind
          these costs for prior approval. Late cancellation charges may be
          applicable where incurred.
          <br /><br />
          K2 Corporate Mobility reserves the right to apply a 15% administration
          fee on pass through costs paid on behalf of the client in a foreign
          currency, with a minimum fee equivalent of GBP 25.00 and a maximum fee
          equivalent of GBP 500.00. This also applies to duties, taxes,
          demurrage, port charges etc.
        </div>
      </div>
    </div>
    <div class="small-divider black-background"></div>
  </div>
  }
</div>

<div class="position-fixed small-menu-container regular-font-size">
  <div
    class="close-menu-btn"
    [class.d-none]="!showMenu"
    (click)="onMenuClick()"
  >
    <mat-icon>close</mat-icon>
  </div>
  <div class="bid-summary-menu" [class.d-none]="!showMenu">
    <div class="bid-summary-navigation">
      @for (item of navigations; track item) {
      <div
        class="navigation-item small-font-size"
        (click)="closeAndScroll(item.link)"
      >
        {{ item.title }}
      </div>
      }
    </div>
  </div>
</div>

<ng-template #btnIcon let-id>
  @switch (id) { @case ('leaves') {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <path
      d="M14.253 30.18c-0.015 0-0.029 0-0.047-0.003-3.431-0.237-6.265-1.631-8.425-4.143-3.521-4.1-5.069-11.008-4.363-19.451 0.029-0.361 0.321-0.66 0.703-0.609 4.747 0.277 9.948 3.045 13.576 7.224 3.303 3.801 4.924 8.252 4.572 12.539-0.031 0.364-0.339 0.628-0.72 0.609-0.367-0.031-0.64-0.355-0.611-0.719 0.323-3.924-1.187-8.028-4.249-11.556-3.232-3.724-7.772-6.251-11.995-6.712-0.532 7.676 0.947 14.14 4.095 17.807 1.917 2.232 4.444 3.472 7.505 3.68 0.367 0.027 0.644 0.344 0.62 0.711-0.019 0.352-0.312 0.623-0.661 0.623zM17.748 31.361c-0.305 0-0.58-0.211-0.649-0.521-1.608-7.159-9.288-16.467-12.544-19.611-0.265-0.253-0.273-0.675-0.019-0.941 0.256-0.264 0.68-0.271 0.943-0.019 3.347 3.236 11.245 12.827 12.919 20.277 0.081 0.361-0.145 0.713-0.504 0.8-0.048 0.011-0.097 0.015-0.145 0.015zM19.671 24.289c-0.309 0-0.585-0.216-0.652-0.531-0.076-0.36 0.156-0.713 0.516-0.789 10.043-2.101 10.111-15.788 9.765-20.943-5.8 0.629-11.848 5.075-14.577 10.795-0.159 0.333-0.559 0.472-0.889 0.315-0.332-0.159-0.473-0.556-0.315-0.888 3.028-6.348 9.907-11.229 16.356-11.607 0.355-0.035 0.675 0.251 0.703 0.609 1.072 12.781-2.955 21.388-10.771 23.025-0.047 0.008-0.091 0.013-0.136 0.013zM17.747 18.057c-0.115 0-0.231-0.028-0.336-0.091-0.317-0.188-0.424-0.593-0.237-0.915 3.067-5.233 7.295-10.143 9.389-12.169 0.267-0.252 0.688-0.249 0.943 0.019 0.255 0.261 0.249 0.688-0.016 0.943-2.041 1.972-6.167 6.765-9.167 11.887-0.125 0.207-0.348 0.327-0.576 0.327z"
    ></path>
  </svg>
  } @case ('right-arrow') {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <path
      d="M12 31.999h-8c-0.275 0-0.521-0.168-0.621-0.423-0.1-0.256-0.032-0.549 0.171-0.735l15.487-14.195-15.508-15.508c-0.191-0.191-0.248-0.475-0.144-0.724 0.103-0.249 0.347-0.413 0.616-0.413h8c0.177 0 0.347 0.071 0.472 0.195l16 16c0.129 0.128 0.197 0.304 0.195 0.485-0.004 0.183-0.083 0.355-0.216 0.476l-16 14.667c-0.123 0.112-0.284 0.175-0.451 0.175zM5.715 30.665h6.028l15.296-14.020-15.315-15.313h-6.115l14.861 14.861c0.129 0.128 0.197 0.304 0.195 0.485-0.004 0.184-0.083 0.356-0.216 0.477l-14.735 13.509z"
    ></path>
  </svg>
  } }
</ng-template>

<ng-template #transitIcon let-id>
  @switch (id) {
  <!-- air transit-->
  @case ('AIR') {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <path
      d="M16.724 27.461c-0.167 0-0.329-0.065-0.453-0.18l-6.196-5.708c-0.271-0.251-0.288-0.673-0.036-0.943 0.249-0.267 0.672-0.289 0.94-0.036l5.615 5.173 12.505-19.365-26.375 8.357 4.355 3.473c0.291 0.229 0.337 0.648 0.105 0.936-0.228 0.291-0.648 0.335-0.935 0.105l-5.331-4.255c-0.195-0.151-0.287-0.401-0.241-0.639 0.044-0.243 0.219-0.44 0.453-0.515l29.333-9.297c0.271-0.083 0.56 0.011 0.735 0.232 0.172 0.224 0.183 0.528 0.028 0.765l-13.94 21.589c-0.107 0.165-0.281 0.275-0.473 0.3-0.035 0.003-0.061 0.005-0.089 0.005zM6.621 26.009c-0.079 0-0.156-0.013-0.233-0.039-0.26-0.097-0.433-0.349-0.433-0.628v-6.635c0-0.368 0.3-0.667 0.667-0.667s0.667 0.299 0.667 0.667v4.844l2.7-3.125c0.243-0.28 0.664-0.307 0.94-0.068 0.279 0.241 0.307 0.661 0.069 0.94l-3.872 4.476c-0.128 0.153-0.313 0.235-0.504 0.235zM10.495 21.529c-0.197 0-0.396-0.088-0.528-0.257-0.227-0.291-0.173-0.709 0.12-0.935l12.985-10.084-16.091 9.080c-0.32 0.18-0.727 0.068-0.911-0.251-0.181-0.321-0.068-0.728 0.251-0.912l24.012-13.545c0.305-0.172 0.688-0.080 0.88 0.211 0.195 0.292 0.133 0.683-0.143 0.896l-20.171 15.657c-0.119 0.095-0.263 0.14-0.405 0.14z"
    ></path>
  </svg>
  }
  <!-- see fcl transit-->
  @case ('SEA_FCL') {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <path
      d="M28 28c-1.103 0-2-0.897-2-2 0-0.367-0.3-0.667-0.667-0.667s-0.667 0.3-0.667 0.667c0 1.103-0.897 2-2 2s-2-0.897-2-2c0-0.367-0.299-0.667-0.667-0.667-0.367 0-0.667 0.3-0.667 0.667 0 1.103-0.897 2-2 2s-2-0.897-2-2c0-0.367-0.299-0.667-0.667-0.667-0.367 0-0.667 0.3-0.667 0.667 0 1.103-0.897 2-2 2s-2-0.897-2-2c0-0.367-0.299-0.667-0.667-0.667-0.367 0-0.667 0.3-0.667 0.667 0 1.103-0.897 2-2 2s-2-0.897-2-2c0-0.367-0.299-0.667-0.667-0.667-0.367 0-0.667 0.3-0.667 0.667s-0.299 0.667-0.667 0.667c-0.367 0-0.667-0.3-0.667-0.667 0-1.103 0.897-2 2-2s2 0.897 2 2c0 0.367 0.3 0.667 0.667 0.667 0.368 0 0.667-0.3 0.667-0.667 0-1.103 0.897-2 2-2s2 0.897 2 2c0 0.367 0.3 0.667 0.667 0.667 0.368 0 0.667-0.3 0.667-0.667 0-1.103 0.897-2 2-2s2 0.897 2 2c0 0.367 0.3 0.667 0.667 0.667 0.368 0 0.667-0.3 0.667-0.667 0-1.103 0.897-2 2-2s2 0.897 2 2c0 0.367 0.3 0.667 0.667 0.667s0.667-0.3 0.667-0.667c0-1.103 0.897-2 2-2s2 0.897 2 2c0 0.367 0.3 0.667 0.667 0.667s0.667-0.3 0.667-0.667 0.3-0.667 0.667-0.667 0.667 0.3 0.667 0.667c0 1.103-0.897 2-2 2zM5.333 26.667c-0.237 0-0.468-0.128-0.587-0.352l-4.667-8.667c-0.111-0.205-0.105-0.456 0.015-0.659 0.119-0.199 0.336-0.323 0.571-0.323h21.057l2.472-2.472c0.125-0.127 0.295-0.195 0.472-0.195h6.667c0.228 0 0.44 0.115 0.563 0.305 0.123 0.195 0.139 0.433 0.041 0.639l-4.667 10c-0.156 0.333-0.551 0.477-0.887 0.32-0.333-0.156-0.477-0.552-0.321-0.885l4.224-9.052h-5.344l-2.472 2.472c-0.128 0.127-0.297 0.195-0.472 0.195h-20.216l4.139 7.687c0.175 0.324 0.053 0.729-0.272 0.905-0.1 0.055-0.208 0.081-0.316 0.081zM8.667 18h-6.667c-0.367 0-0.667-0.3-0.667-0.667v-6.667c0-0.367 0.3-0.667 0.667-0.667h6.667c0.368 0 0.667 0.3 0.667 0.667v6.667c0 0.367-0.299 0.667-0.667 0.667zM2.667 16.667h5.333v-5.333h-5.333v5.333zM3.333 10.667c-0.367 0-0.667-0.3-0.667-0.667v-5.333c0-0.367 0.3-0.667 0.667-0.667 0.368 0 0.667 0.3 0.667 0.667v5.333c0 0.367-0.299 0.667-0.667 0.667zM7.333 10.667c-0.367 0-0.667-0.3-0.667-0.667v-2.667c0-0.367 0.3-0.667 0.667-0.667 0.368 0 0.667 0.3 0.667 0.667v2.667c0 0.367-0.299 0.667-0.667 0.667zM15.333 18h-4c-0.367 0-0.667-0.3-0.667-0.667v-5.333c0-0.367 0.3-0.667 0.667-0.667h4c0.368 0 0.667 0.3 0.667 0.667v5.333c0 0.367-0.299 0.667-0.667 0.667zM12 16.667h2.667v-4h-2.667v4zM19.333 18h-4c-0.367 0-0.667-0.3-0.667-0.667v-8c0-0.367 0.3-0.667 0.667-0.667h4c0.368 0 0.667 0.3 0.667 0.667v8c0 0.367-0.299 0.667-0.667 0.667zM16 16.667h2.667v-6.667h-2.667v6.667z"
    ></path>
  </svg>
  }
  <!-- see lcl transit-->
  @case ('SEA_LCL') {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <path
      d="M22 30.667c-0.079 0-0.157-0.013-0.235-0.043-0.344-0.129-0.519-0.512-0.389-0.859l3.747-9.989-8.455-2.417-8.455 2.417 3.747 9.989c0.129 0.347-0.045 0.729-0.389 0.859-0.345 0.132-0.729-0.044-0.859-0.389l-4-10.667c-0.065-0.175-0.055-0.367 0.029-0.533s0.233-0.289 0.412-0.341l9.333-2.667c0.12-0.031 0.247-0.031 0.364 0l9.333 2.667c0.18 0.052 0.329 0.175 0.413 0.341 0.083 0.167 0.095 0.361 0.029 0.533l-4 10.667c-0.103 0.268-0.357 0.432-0.627 0.432zM24 18.667h-1.333v-9.333h-12v9.333h-1.333v-10c0-0.367 0.299-0.667 0.667-0.667h13.333c0.367 0 0.667 0.3 0.667 0.667v10zM22 9.333h-10.667c-0.368 0-0.667-0.3-0.667-0.667v-2.667c0-0.367 0.299-0.667 0.667-0.667h10.667c0.367 0 0.667 0.3 0.667 0.667v2.667c0 0.367-0.3 0.667-0.667 0.667zM12 8h9.333v-1.333h-9.333v1.333zM14 6c-0.368 0-0.667-0.3-0.667-0.667v-2.667c0-0.367 0.299-0.667 0.667-0.667s0.667 0.3 0.667 0.667v2.667c0 0.367-0.299 0.667-0.667 0.667zM19.333 6c-0.367 0-0.667-0.3-0.667-0.667v-4c0-0.367 0.3-0.667 0.667-0.667s0.667 0.3 0.667 0.667v4c0 0.367-0.3 0.667-0.667 0.667zM26.667 31.333c-1.103 0-2-0.897-2-2 0-0.367-0.3-0.667-0.667-0.667s-0.667 0.3-0.667 0.667c0 1.103-0.897 2-2 2s-2-0.897-2-2c0-0.367-0.3-0.667-0.667-0.667s-0.667 0.3-0.667 0.667c0 1.103-0.897 2-2 2s-2-0.897-2-2c0-0.367-0.299-0.667-0.667-0.667s-0.667 0.3-0.667 0.667c0 1.103-0.897 2-2 2s-2-0.897-2-2c0-0.367-0.299-0.667-0.667-0.667s-0.667 0.3-0.667 0.667c0 1.103-0.897 2-2 2s-2-0.897-2-2c0-0.367 0.299-0.667 0.667-0.667s0.667 0.3 0.667 0.667 0.299 0.667 0.667 0.667 0.667-0.3 0.667-0.667c0-1.103 0.897-2 2-2s2 0.897 2 2c0 0.367 0.299 0.667 0.667 0.667s0.667-0.3 0.667-0.667c0-1.103 0.897-2 2-2s2 0.897 2 2c0 0.367 0.299 0.667 0.667 0.667s0.667-0.3 0.667-0.667c0-1.103 0.897-2 2-2s2 0.897 2 2c0 0.367 0.3 0.667 0.667 0.667s0.667-0.3 0.667-0.667c0-1.103 0.897-2 2-2s2 0.897 2 2c0 0.367 0.3 0.667 0.667 0.667s0.667-0.3 0.667-0.667 0.3-0.667 0.667-0.667 0.667 0.3 0.667 0.667c0 1.103-0.897 2-2 2zM16.667 16h-4c-0.368 0-0.667-0.3-0.667-0.667v-4c0-0.367 0.299-0.667 0.667-0.667h4c0.367 0 0.667 0.3 0.667 0.667v4c0 0.367-0.3 0.667-0.667 0.667zM13.333 14.667h2.667v-2.667h-2.667v2.667zM20.667 16h-4c-0.368 0-0.667-0.3-0.667-0.667v-4c0-0.367 0.299-0.667 0.667-0.667h4c0.367 0 0.667 0.3 0.667 0.667v4c0 0.367-0.3 0.667-0.667 0.667zM17.333 14.667h2.667v-2.667h-2.667v2.667z"
    ></path>
  </svg>
  }
  <!-- road transit-->
  @case ('ROAD') {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <path
      d="M29.419 28.015h-26.837c-0.677 0-1.324-0.289-1.776-0.792-0.452-0.505-0.671-1.177-0.599-1.852l0.721-6.812c0.017-0.169 0.1-0.325 0.228-0.437l1.299-1.112 1.121-8.972c0.287-2.297 2.248-4.028 4.56-4.028h15.728c2.312 0 4.276 1.732 4.56 4.028l1.125 8.984 1.323 1.207c0.121 0.109 0.195 0.259 0.213 0.42l0.708 6.716c0.073 0.675-0.145 1.351-0.599 1.853-0.452 0.509-1.101 0.797-1.776 0.797zM2.224 18.963l-0.693 6.552c-0.031 0.297 0.065 0.593 0.265 0.817 0.2 0.221 0.485 0.349 0.784 0.349h26.839c0.299 0 0.584-0.128 0.784-0.349 0.197-0.224 0.297-0.523 0.265-0.815l-0.687-6.469-1.316-1.203c-0.119-0.107-0.195-0.252-0.211-0.409l-1.153-9.229c-0.203-1.633-1.595-2.861-3.237-2.861h-15.728c-1.641 0-3.033 1.229-3.237 2.861l-1.153 9.224c-0.020 0.164-0.101 0.312-0.227 0.42l-1.295 1.112zM6.667 24.028c-1.471 0-2.667-1.195-2.667-2.668 0-1.471 1.196-2.665 2.667-2.665s2.667 1.195 2.667 2.665-1.196 2.668-2.667 2.668zM6.667 20.028c-0.735 0-1.333 0.599-1.333 1.332 0 0.736 0.599 1.335 1.333 1.335s1.333-0.599 1.333-1.335c0-0.733-0.599-1.332-1.333-1.332zM25.333 24.028c-1.472 0-2.667-1.195-2.667-2.668 0-1.471 1.195-2.665 2.667-2.665s2.667 1.195 2.667 2.665-1.195 2.668-2.667 2.668zM25.333 20.028c-0.736 0-1.333 0.599-1.333 1.332 0 0.736 0.597 1.335 1.333 1.335s1.333-0.599 1.333-1.335c0-0.733-0.597-1.332-1.333-1.332zM10.667 18.681h10.667v1.333h-10.667v-1.333zM10.667 21.348h10.667v1.333h-10.667v-1.333zM31.333 18.681h-2v-1.333h1.333v-16h-29.333v16h1.333v1.333h-2c-0.368 0-0.667-0.3-0.667-0.667v-17.333c0-0.367 0.299-0.667 0.667-0.667h30.667c0.367 0 0.667 0.3 0.667 0.667v17.333c0 0.367-0.3 0.667-0.667 0.667zM5.333 31.985c-1.471 0-2.667-1.184-2.667-2.639v-1.333h1.333v1.333c0 0.732 0.585 1.305 1.333 1.305 0.723 0 1.333-0.623 1.333-1.361v-1.277h1.333v1.279c0 1.487-1.196 2.693-2.667 2.693zM26.667 31.985c-1.472 0-2.667-1.184-2.667-2.639v-1.333h1.333v1.333c0 0.732 0.585 1.305 1.333 1.305 0.723 0 1.333-0.623 1.333-1.361v-1.277h1.333v1.279c0 1.487-1.195 2.693-2.667 2.693zM20.667 25.348h-9.333c-0.368 0-0.667-0.3-0.667-0.667v-8c0-0.367 0.299-0.667 0.667-0.667h9.333c0.367 0 0.667 0.3 0.667 0.667v8c0 0.367-0.3 0.667-0.667 0.667zM12 24.015h8v-6.667h-8v6.667zM4 13.348h24v1.333h-24v-1.333zM6.667 8.681c-0.175 0-0.351-0.069-0.481-0.203-0.255-0.269-0.247-0.691 0.020-0.944l1.389-1.333c0.265-0.256 0.687-0.248 0.943 0.020 0.255 0.267 0.247 0.692-0.020 0.943l-1.389 1.333c-0.128 0.123-0.295 0.184-0.461 0.184zM6.667 11.239c-0.173 0-0.347-0.068-0.477-0.2-0.256-0.267-0.251-0.688 0.013-0.944l4-3.891c0.264-0.255 0.685-0.251 0.943 0.013 0.256 0.263 0.251 0.688-0.013 0.943l-4 3.891c-0.131 0.125-0.299 0.188-0.465 0.188zM10 4.681c-0.368 0-0.667-0.3-0.667-0.667v-1.333c0-0.367 0.299-0.667 0.667-0.667s0.667 0.299 0.667 0.667v1.333c0 0.367-0.299 0.667-0.667 0.667zM22 4.681c-0.367 0-0.667-0.3-0.667-0.667v-1.333c0-0.367 0.3-0.667 0.667-0.667s0.667 0.3 0.667 0.667v1.333c0 0.367-0.3 0.667-0.667 0.667z"
    ></path>
  </svg>
  }
  <!-- special transit-->
  @case ('special_items') {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <path
      d="M31.333 32h-30.667c-0.368 0-0.667-0.3-0.667-0.667v-30.667c0-0.367 0.299-0.667 0.667-0.667h30.667c0.367 0 0.667 0.3 0.667 0.667v30.667c0 0.367-0.3 0.667-0.667 0.667zM1.333 30.667h29.333v-29.333h-29.333v29.333zM26.027 25.333c-0.008 0-0.017 0-0.027 0h-12c-0.26 0-0.496-0.151-0.605-0.387l-4-8.667c-0.040-0.087-0.061-0.184-0.061-0.28v-8.667c0-0.367 0.299-0.667 0.667-0.667h12c0.367 0 0.667 0.3 0.667 0.667v8.521l3.867 8.383c0.099 0.115 0.159 0.265 0.159 0.429 0.001 0.367-0.297 0.667-0.665 0.667zM14.427 24h10.532l-3.564-7.72c-0.040-0.087-0.061-0.184-0.061-0.28v-8h-10.667v7.855l3.76 8.145zM14.667 25.333h-4.667c-0.368 0-0.667-0.3-0.667-0.667v-8.667c0-0.367 0.299-0.667 0.667-0.667s0.667 0.3 0.667 0.667v8h4c0.368 0 0.667 0.3 0.667 0.667s-0.299 0.667-0.667 0.667zM21.333 16h-10.667c-0.368 0-0.667-0.3-0.667-0.667s0.299-0.667 0.667-0.667h10.667c0.367 0 0.667 0.3 0.667 0.667s-0.3 0.667-0.667 0.667z"
    ></path>
  </svg>
  } }
</ng-template>
